<template>
    <div v-if="authedUser" ref="side-nav" :class="navClass">
        <div class="side-nav-links">
            <div class="nav-header">
                <img
                    :src="userAvatar"
                    :style="!showFullBarContents ? { width: '32px', height: '32px' } : {}"
                    class="user-avatar"
                />
                <p v-if="showFullBarContents" class="user-greeting">Hi, {{ userFirstName }}</p>
                <img
                    v-if="showFullBarContents && width > 768"
                    :src="
                        buttonStates.shrinkHovered
                            ? URLS.icons.leftArrow.yellow
                            : URLS.icons.leftArrow.grey
                    "
                    @mouseover="buttonStates.shrinkHovered = true"
                    @mouseleave="buttonStates.shrinkHovered = false"
                    @click="shrinkBar"
                    class="toggle-bar-btn shrink-btn"
                />
                <img
                    @click="hideMobileMenu"
                    v-if="width <= 768"
                    :src="getIcon + 'Delete.png'"
                    class="toggle-bar-btn shrink-btn"
                    style="position: absolute; right: 35px"
                />
            </div>

            <div class="nav-divider"></div>

            <div class="nav-content-primary">
                <div
                    v-for="(item, indx) in navPrimaryContent"
                    :key="indx"
                    class="side-nav-item"
                    :class="!item.current ? item.customClass : ''"
                >
                    <a
                        :href="item.func ? '#' : item.src"
                        @click="item.func ? item.call(item) : null"
                        @mouseover="handleHovered(item)"
                        @mouseleave="handleUnhovered(item)"
                        class="side-nav-link"
                        :class="item.current ? 'current-nav-item' : ''"
                    >
                        <img
                            v-if="width > 768"
                            class="side-nav-item-icon"
                            :src="
                                item.hovered || item.current
                                    ? item.icon.yellow
                                    : item.icon.grey
                            "
                        />
                        <p v-if="showFullBarContents" class="side-nav-item-text">
                            {{ item.text }}
                        </p>
                    </a>
                    <div
                        v-if="showFullBarContents && item.sublinksVisible && item.sublinks"
                        class="nav-sublinks"
                    >
                        <div
                            v-for="(sublink, indx) in item.sublinks"
                            :key="indx"
                            class="nav-sublink"
                        >
                            <span class="nav-sublink-dot"></span>
                            <a class="nostyle" :href="sublink.src">{{ sublink.text }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="nav-divider"></div>

            <div class="nav-content-secondary">
                <div
                    v-for="(item, indx) in navSecondaryContent"
                    :key="indx"
                    class="side-nav-item"
                >
                    <a
                        :href="item.func ? '#' : item.src"
                        @click="item.func ? item.call(item) : null"
                        @mouseover="handleHovered(item)"
                        @mouseleave="handleUnhovered(item)"
                        :class="item.current ? 'current-nav-item' : ''"
                        class="side-nav-link"
                    >
                        <img
                            v-if="width > 768"
                            class="side-nav-item-icon"
                            :src="
                                item.hovered || item.current
                                    ? item.icon.yellow
                                    : item.icon.grey
                            "
                        />
                        <p v-if="showFullBarContents" class="side-nav-item-text">
                            {{ item.text }}
                        </p>
                    </a>
                    <div
                        v-show="showFullBarContents && item.sublinksVisible && item.sublinks"
                        class="nav-sublinks"
                    >
                        <div
                            v-for="(sublink, indx) in item.sublinks"
                            :key="indx"
                            class="nav-sublink"
                        >
                            <span class="nav-sublink-dot"></span>
                            <a class="nostyle" :href="sublink.src">{{ sublink.text }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="nav-divider" v-if="width <= 768"></div>

            <div class="nav-content-mobile-only" v-if="width <= 768">
                <div
                    v-for="(item, indx) in navMobileOnlyContent"
                    :key="indx"
                    class="side-nav-item"
                >
                    <a
                        :href="item.func ? '#' : item.src"
                        @click="item.func ? item.call(item) : null"
                        @mouseover="handleHovered(item)"
                        @mouseleave="handleUnhovered(item)"
                        :class="item.current ? 'current-nav-item' : ''"
                        class="side-nav-link"
                    >
                        <p v-if="showFullBarContents" class="side-nav-item-text">
                            {{ item.text }}
                        </p>
                    </a>
                    <div
                        v-show="showFullBarContents && item.sublinksVisible && item.sublinks"
                        class="nav-sublinks"
                    >
                        <div
                            v-for="(sublink, indx) in item.sublinks"
                            :key="indx"
                            class="nav-sublink"
                        >
                            <span class="nav-sublink-dot"></span>
                            <a class="nostyle" :href="sublink.src">{{ sublink.text }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="nav-divider" v-if="width <= 768"></div>

            <div class="nav-footer">
                <div
                    class="log-off-wrapper"
                    @mouseover="buttonStates.logOffHovered = true"
                    @mouseleave="buttonStates.logOffHovered = false"
                    @click="logOut"
                >
                    <img
                        :src="
                            buttonStates.logOffHovered
                                ? URLS.icons.Logoff.yellow
                                : URLS.icons.Logoff.grey
                        "
                        v-if="width > 768"
                    />
                    <div
                        class="logout-btn"
                        v-if="showFullBarContents"
                        :class="{ 'yellow-text': buttonStates.logOffHovered }"
                    >
                        Log Off
                    </div>
                </div>
                <div v-if="!showFullBarContents">
                    <div class="nav-divider"></div>
                    <div class="toggle-bar-btn">
                        <img
                            :src="
                                buttonStates.expandHovered
                                    ? URLS.icons.rightArrow.yellow
                                    : URLS.icons.rightArrow.grey
                            "
                            @mouseover="buttonStates.expandHovered = true"
                            @mouseleave="buttonStates.expandHovered = false"
                            @click="expandBar"
                            class="toggle-bar-btn expand-btn"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import checkScreen from '@/mixins/check-screen'
    import { api } from '@/helpers/api'

    const URLS = {
        icons: {
            leftArrow: {
                grey: '/images/icons/side-nav/new/left-arrow-grey.svg',
                yellow: '/images/icons/side-nav/new/left-arrow-yellow.svg'
            },
            rightArrow: {
                grey: '/images/icons/side-nav/new/right-arrow-grey.svg',
                yellow: '/images/icons/side-nav/new/right-arrow-yellow.svg'
            },
            Logoff: {
                grey: '/images/icons/side-nav/new/Logoff.svg',
                yellow: '/images/icons/side-nav/new/Logoff-yellow.svg'
            }
        },

        xhr: {
            checkAuth: '/api/check-authorization',
            user: '/api/profile/v1/settings/user',
            logout: '/logout'
        },

        redirect: {
            home: '/'
        }
    }

    export default {
        name: 'SideNav',

        mixins: [checkScreen],

        props: {
            parent: {
                type: String,
                required: false,
                default: 'none',
                validator: (val) => ['none', 'profile', 'booking-manager'].includes(val)
            }
        },

        data: () => ({
            scrollY: 0,
            windowHeight: document.documentElement.scrollHeight,
            headerHeight: 75,
            footerHeight: 315,
            sideNavOriginalHeight: 0,
            showFullBar: true,
            showAccount: true,
            showSublinks: false,
            userInfo: {},
            authedUser: false,

            csrf: document.head.querySelector('meta[name="csrf-token"]')['content'],

            buttonStates: {
                shrinkHovered: false,
                expandHovered: false,
                logOffHovered: false
            }
        }),

        methods: {
            hideMobileMenu() {
                this.$emit('hideModal')
            },
            showAccountSettings() {
                this.$emit('update:isVisibleShowAccount', this.showAccount)
            },

            async logOut() {
                await api({
                    method: 'post',
                    url: this.URLS.xhr.logout,
                    data: {
                        token: this.csrf
                    }
                })
                window.location.href = URLS.redirect.home
            },

            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            },

            handleHovered(item) {
                let menuItem = this.menuItems.find((i) => i.text === item.text)
                menuItem.hovered = true
            },

            handleShowSublinks(item) {
                let menuItem = this.menuItems.find((i) => i.text === item.text)
                menuItem.sublinksVisible = !menuItem.sublinksVisible
                this.$forceUpdate()
            },

            handleUnhovered(item) {
                let menuItem = this.menuItems.find((i) => i.text === item.text)
                menuItem.hovered = false
            },

            resetBtnHover() {
                this.buttonStates.expandHovered = false
                this.buttonStates.shrinkHovered = false
                this.buttonStates.logOffHovered = false
            },

            expandBar() {
                this.showFullBar = true
                this.scrollToTop()
                this.resetBtnHover()
            },

            shrinkBar() {
                this.showFullBar = false
                this.resetBtnHover()
            },

            onScroll() {
                this.scrollY = window.top.scrollY
            },

            onResize() {
                this.windowHeight = document.documentElement.scrollHeight
            },

            highlightCurrentRoute() {
                let currentRoute = window.location.pathname

                if (currentRoute.includes('?')) {
                    currentRoute = currentRoute.split('?')[0]
                }

                const matchRoute = this.menuItems.find((i) => {
                    if (!i.src || i.src === '#') {
                        return i.src.venue === currentRoute || i.src.artist === currentRoute
                    } else if (i.src && i.src !== '#') {
                        return (
                            i.src === currentRoute ||
                            i.sublinks?.some((sublink) => sublink.src === currentRoute)
                        )
                    }
                })

                if (matchRoute) matchRoute.current = true
            },

            async getUserSettings() {
                const data = await api({
                    method: 'get',
                    url: this.URLS.xhr.user
                })
                this.userInfo = data.data[0]

                this.$emit('update:userInfo', this.userInfo)
            },

            async isAuthed() {
                try {
                    const data = await api(
                        {
                            method: 'get',
                            url: this.URLS.xhr.checkAuth
                        },
                        { error: false }
                    )

                    this.authedUser = data.isAuthorized
                    this.$emit('update:authedUser', this.authedUser)
                } catch {
                    this.authedUser = false
                }
            }
        },
        computed: {
            menuItems: (self) => [
                {
                    category: 'primary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false,
                    call: null,
                    text: 'My Events',
                    src: '/booking-manager',
                    icon: {
                        grey: '/images/icons/side-nav/new/calendar-grey.svg',
                        yellow: '/images/icons/side-nav/new/calendar-yellow.svg'
                    }
                },
                {
                    category: 'primary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false, //true,
                    call: null /*(item) => {
                        self.handleShowSublinks(item)
                    },*/,
                    text: 'Explore',
                    src: '/exploration',
                    icon: {
                        grey: '/images/icons/search_icon_grey.svg',
                        yellow: '/images/icons/search_icon_yellow.svg'
                    } /*,
                    sublinks: [
                        {
                            text: 'Artist Pages',
                            src: '/search'
                        },
                        {
                            text: 'Venue Pages',
                            src: '/venue-search'
                        },
                        {
                            text: 'Opportunities',
                            src: '/opportunities'
                        },
                        {
                            text: 'Events',
                            src: '/events'
                        }
                    ] */
                },
                {
                    category: 'primary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false, //true
                    call: null, //(item) => self.handleShowSublinks(item),
                    role: 'both',
                    text: 'My Pages',
                    src: '/profiles',
                    icon: {
                        grey: '/images/icons/side-nav/new/my-pages-new-grey.svg',
                        yellow: '/images/icons/side-nav/new/my-pages-new-yellow.svg'
                    } /*,
                    sublinks:
                        self.userInfo.artistPages?.length || self.userInfo.venuePages?.length
                            ? [
                                  ...self.userInfo.artistPages.map((page) => ({
                                      text: page.band_name,
                                      src: '/artists/' + page.slug
                                  })),
                                  ...self.userInfo.venuePages.map((page) => ({
                                      text: page.venue_name,
                                      src: '/venues/' + page.slug
                                  }))
                              ]
                            : [] */
                },
                {
                    category: 'secondary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: self.parent === 'profile' ? true : false,
                    call: self.showAccountSettings,
                    text: 'My Profile',
                    src: '/profile/v1/user-profile/settings',
                    icon: {
                        grey: '/images/icons/side-nav/new/settings-grey.svg',
                        yellow: '/images/icons/side-nav/new/settings-yellow.svg'
                    }
                },
                /*{
                    category: 'secondary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false,
                    call: null,
                    text: 'Contacts',
                    src: '/profile/contacts',
                    icon: {
                        grey: '/images/icons/side-nav/new/contacts-new-grey.svg',
                        yellow: '/images/icons/side-nav/new/contacts-new-yellow.svg'
                    }
                },*/
                {
                    category: 'secondary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false,
                    call: null,
                    text: 'Messages',
                    src: '/profile/mail-chat',
                    icon: {
                        grey: '/images/icons/side-nav/new/messages-new-grey.svg',
                        yellow: '/images/icons/side-nav/new/messages-new-yellow.svg'
                    }
                },
                {
                    category: 'secondary',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: true,
                    call: (item) => self.handleShowSublinks(item),
                    text: 'Billing',
                    src: '#',
                    icon: {
                        grey: '/images/icons/side-nav/new/billing-new-grey.svg',
                        yellow: '/images/icons/side-nav/new/billing-new-yellow.svg'
                    },
                    sublinks: [
                        {
                            text: 'Payment Details',
                            src: '/profile/payment-details'
                        },
                        {
                            text: 'Get Paid',
                            src: '/profile/stripe-profile'
                        },
                        {
                            text: 'Subscriptions',
                            src: '/profile/stripe/plans/venue'
                        },
                        {
                            text: 'Billing History',
                            src: '/profile/billing-history'
                        }
                    ]
                },
                {
                    category: 'mobile',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false,
                    call: null,
                    text: 'FAQs',
                    src: '/faqs',
                    icon: null
                },
                {
                    category: 'mobile',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false,
                    call: null,
                    text: 'About Us',
                    src: '/about-us',
                    icon: null
                },
                {
                    category: 'mobile',
                    hovered: false,
                    sublinksVisible: false,
                    current: false,
                    func: false,
                    call: null,
                    text: 'Contact Us',
                    src: '/contact-us',
                    icon: null
                }
            ],
            getIcon() {
                return '/images/'
            },
            URLS: () => URLS,

            userAvatar: (self) => {
                if (self.userInfo?.avatar) {
                    if (self.userInfo.avatar[0] !== '/') {
                        return '/' + self.userInfo.avatar
                    }

                    return self.userInfo.avatar
                } else {
                    return '/images/icons/side-nav/profile.png'
                }
            },

            userFirstName: (self) =>
                self.userInfo.first_name ? self.userInfo.first_name : 'Hedlyner user',

            navPrimaryContent: (self) =>
                self.menuItems.filter((i) => i.category === 'primary'),
            navSecondaryContent: (self) =>
                self.menuItems.filter((i) => i.category === 'secondary'),
            navMobileOnlyContent: (self) =>
                self.menuItems.filter((i) => i.category === 'mobile'),
            navClass: (self) => {
                let _class = {
                    'side-nav-container': true
                }

                if (self.showFullBar) {
                    _class['full-bar'] = true
                } else if (!self.showFullBar) {
                    _class['full-bar'] = true
                    _class['mini-bar'] = true
                }
                if (self.hideShortBar) {
                    _class['full-bar'] = true
                } else if (!self.hideShortBar) {
                    _class['full-bar'] = true
                    _class['mini-bar'] = true
                    _class['short-bar'] = true
                }

                return _class
            },

            viewHeight: (self) =>
                self.windowHeight - self.scrollY - self.headerHeight - self.footerHeight,

            hideShortBar: (self) =>
                self.$parent?.$options?.name === 'Header' || self.scrollY < self.viewHeight,
            showFullBarContents: (self) => self.showFullBar && self.hideShortBar
        },

        watch: {
            authedUser: function (newState, oldState) {
                if (newState === true && oldState === false) {
                    this.$nextTick(() => {
                        this.sideNavOriginalHeight = this.$refs['side-nav'].clientHeight
                    })
                }
            }
        },

        async created() {
            if (
                this.width <= 768 &&
                (!this.$parent.$options.name || !this.$parent.$options.name === 'Header')
            )
                return

            await this.isAuthed()

            if (this.authedUser) {
                await this.getUserSettings()
            }
        },

        mounted() {
            window.addEventListener('scroll', this.onScroll)
            window.addEventListener('resize', this.onResize)
            this.highlightCurrentRoute()
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.onScroll)
            window.removeEventListener('resize', this.onResize)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';

    .side-nav-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 18px 20px 20px 20px;
        border-radius: 15px;
        background: $dark;
        height: 862px;
        overflow: hidden;

        &.full-bar {
            max-width: 210px;
            max-height: 862px;
            transition: all 0.5s;

            &.mini-bar {
                max-width: 64px;
                max-height: 862px;
                transition: all 0.5s ease;

                .user-avatar {
                    margin-left: 0px !important;
                }

                .side-nav-link {
                    margin-right: 17px;
                }

                .toggle-bar-btn {
                    margin-top: 10px;
                }

                &.short-bar {
                    max-width: 64px;
                    max-height: 700px;
                    transition: all 0.5s;
                }
            }
        }

        a.nostyle:link {
            text-decoration: inherit;
            color: $darker-grey;
            cursor: pointer;
        }

        a.nostyle:visited {
            text-decoration: inherit;
            color: $darker-grey;
            cursor: pointer;
        }

        .toggle-bar-btn {
            cursor: pointer;
            width: 24px;
            height: 24px;
        }

        .nav-divider {
            height: 1px;
            background: $grey;
            width: 100%;
        }

        .side-nav-links {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;

            .nav-header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                gap: 10px;

                .user-avatar {
                    flex: 0 0 auto;
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                    object-fit: cover;
                }

                .user-greeting {
                    flex: 0 0 auto;
                    width: 95px;
                    overflow: hidden;
                    color: $white;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    font-weight: 550;
                    line-height: 125%;
                    margin-bottom: 0px;
                }
            }

            .nav-content-primary,
            .nav-content-secondary,
            .nav-content-mobile-only {
                margin-top: 15px;
                display: flex;
                flex-direction: column;
                gap: 15px;

                .side-nav-item .current-nav-item {
                    .side-nav-item-text {
                        color: $lime !important;
                    }
                }
                .side-nav-item {
                    display: flex;
                    flex-direction: column;
                    padding: 3px 0px 3px 9px;
                    min-width: 201px;
                    min-height: 24px;

                    &:hover {
                        .side-nav-item-text {
                            color: $lime;
                        }
                    }
                    .side-nav-link {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        gap: 10px;
                        padding: 3px 0px 3px 9px;
                        text-decoration: none;

                        .side-nav-item-icon {
                            height: 24px;
                            width: 24px;
                        }
                        .side-nav-item-text {
                            margin-bottom: 0px;
                            max-width: 167px;
                            width: 100%;
                            min-height: 20px;
                            color: $darker-grey;
                            @include base-font-16;
                            font-weight: 550;
                            line-height: 125%;
                        }
                    }

                    .side-nav-link:hover {
                        .side-nav-item-text {
                            color: $lime;
                        }
                    }

                    .nav-sublinks {
                        display: flex;
                        flex-direction: column;
                        margin-left: 43px;

                        .nav-sublink-dot {
                            margin-right: 5px;
                            display: inline-block;
                            background: $grey;
                            height: 4px;
                            width: 4px;
                        }
                    }

                    .nav-sublink:hover {
                        .nav-sublink-dot {
                            background: $lime;
                        }

                        a {
                            color: $lime;
                        }
                    }
                }
            }

            .nav-footer {
                width: 100%;
                padding: 3px 0px 3px 2px;
                .log-off-wrapper {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding-bottom: 10px;
                    cursor: pointer;
                    .logout-btn {
                        background: transparent;
                        border: none;
                        color: $darker-grey;
                        @include base-font-16;
                        font-weight: 550;
                        line-height: 125%;
                    }
                    .yellow-text {
                        color: $lime;
                    }
                }

                .logout-btn:hover {
                    color: $lime;
                }
            }
        }
    }

    @media screen and (max-width: $mobile) {
        .side-nav-container {
            margin: 16px;
            align-items: flex-start;
            height: 88vh !important;
            overflow-y: scroll !important;
            &.full-bar {
                max-width: 100% !important;
            }
            .side-nav-links {
                align-items: flex-start !important;
                width: 100%;
            }
            .side-nav-item {
                min-width: revert !important;
                padding: 0px !important;
                a {
                    padding: 0px !important;
                }
            }
        }
    }
</style>
